import React from 'react';
import './RadioButtonGroup.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

export const RadioButton = (props, context) => (
  <span className="RadioButton">
    <input type="radio" {...props} />
    {getLabel(context.locale, props.label)}
  </span>
);

RadioButton.contextTypes = {
  locale: PropTypes.string,
};

const RadioButtonGroup = (props, context) => {
  const childrenWithProps = React.Children.map(props.children,
    child => React.cloneElement(child, {
      ...child.props,
      name: props.name,
      checked: String(props.value) === child.props.value,
      onChange: props.handleChange,
    })
  );

  return (
    <div className={classNames('RadioButtonGroup', props.error ? 'hasError' : '')}>
      <div className="inputLabel">
        <span>{getLabel(context.locale, props.label)}</span>
        {props.required ? <span className="required">*</span> : ''}
      </div>
      {childrenWithProps}
    </div>
  );
};

RadioButtonGroup.contextTypes = {
  locale: PropTypes.string,
};

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/main/components/input/RadioButtonGroup.js